import React from 'react';
import { get } from 'lodash';
import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';
import { getScrollTopToTarget } from '../../../../../../utils/scrollUtil.js';

export class SelectForm extends BasicForm {
  containerRef = React.createRef(null);

  state = {
    isOpen: false
  };

  componentDidMount () {
    this.minValue = get(this, 'props.object.validations.min_value', 0);
    this.maxValue = get(this, 'props.object.validations.max_value');

    // this.selectRef.addEventListener('wheel', (e) => {
    //   e.stopPropagation();
    // });
  };

  setValue (_value) {
    const value = this.maxValue === undefined
      ? _value < this.minValue
        ? '' : _value
      : _value < this.minValue || _value > this.maxValue
        ? '' : _value;
    this.props.input.onChange(value);
  }

  selectBodyTpl () {
    const options = [];

    if (this.maxValue && this.maxValue > this.minValue) {
      for (let index = this.minValue; index <= this.maxValue; index++) {
        options.push(index);
      }
    }

    return options.length > 0 ?
      <div className="cu-ui-select-form-body">
        {
          options.map((o, idx) => (
            <div key={idx} onClick={() => this.setValue(o)}>{o}</div>
          ))
        }
      </div> :
      ''
  }

  handleFocus (e) {
    this.setState({ isOpen: true }, () => {
      // Comment for jetting UI
      // const chatBody = document.querySelector('.cu-ui-chat-body');
      // chatBody.scrollTop = getScrollTopToTarget(this.selectRef, chatBody);
    });
    this.handleFocusInput(this.props.input.onFocus)(e);
  }

  handleBlur (e) {
    this.handleBlurInput(this.props.input.onBlur)(e);
    setTimeout(() => {
      this.setState({ isOpen: false });
    }, 500);
  }

  handleChange (e) {
    this.setValue(e.target.value);
  }

  render () {
    return (
      <div className="cu-ui-form-group" ref={el => this.selectRef = el}>
        <FormLabel
          utilText={this.props.utilText}
          valid={this.props.meta.valid}
          label={this.props.object.label}
          required={this.props.object.validations.required}
        />
        <div className="cu-ui-input-container cu-ui-select-form">
          <input
            type="number"
            onFocus={this.handleFocus.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            onChange={this.handleChange.bind(this)}
            value={this.props.input.value}
            disabled={this.props.disabled}
          />
          <span>{this.props.object.unit}</span>
          {
            this.state.isOpen && this.selectBodyTpl()
          }
        </div>
        <FormErrorMessage
          error={this.props.meta.error}
          touched={this.props.meta.touched}
        />
      </div>
    );
  }
}
